import { FC } from "react";
import { List, Stack, SxProps } from "@mui/material";
import { BurnListItem } from "./BurnListItem";
import { BurnNonSensitiveUi } from "../BurnNonSensitiveUi";
import { SizeClass } from "shared-ts-ui-responsive";
import { If } from "shared-ts-ui-react";

export interface BurnListProps {
  burns: Array<BurnNonSensitiveUi> | undefined;
  multiSelect: boolean;
  hideDuration?: boolean;
  hideMarkers?: boolean;
  selected?: Array<boolean>;
  onSelected?: (burns: Array<boolean>) => void;
  dense?: boolean;
  layout?: SizeClass;
  direction?: "row" | "column";
  sx?: SxProps;
}
export const BurnList: FC<BurnListProps> = (props) => {
  return (
    <If
      expression={props.direction === "row"}
      then={(children) => (
        <Stack direction={"row"} style={{ overflow: "scroll" }}>
          {children}
        </Stack>
      )}
      else={(children) => (
        <List disablePadding sx={props.sx}>
          {children}
        </List>
      )}
    >
      {props.burns?.map((burn, burnIndex) => {
        const selected = props.selected?.[burnIndex];

        const handleSelected = (selected: boolean) => {
          if (props.onSelected != null) {
            const newSelected = props.burns?.map((it, index) =>
              index === burnIndex
                ? selected
                : props.multiSelect
                ? props.selected?.[index] ?? false
                : false
            );
            if (newSelected !== undefined) {
              props.onSelected?.(newSelected);
            }
          }
        };
        return (
          <BurnListItem
            key={burn.id}
            burn={burn}
            selected={selected}
            adornment={"startQuality"}
            hideDuration={props.hideDuration}
            hideMarker={props.hideMarkers}
            onSelected={handleSelected}
            dense={props.dense}
            layout={props.layout}
            direction={props.direction}
          />
        );
      })}
    </If>
  );
};
